import {
	Select,
	SelectTrigger,
	SelectValue,
	SelectContent,
	SelectItem,
} from '@/components/ui/select';
import { SIGNUP_GROUP_OPTIONS } from '@/constants';
import { useSignUp } from '@/contexts/signup.context';

// The group is optional, but Radix Select has no native clear and forbids
// empty-value items. This sentinel renders a "None" option that resets the
// group to empty so a user can unselect it after picking one.
const NO_GROUP_VALUE = '__none__';

export const GroupSelectForm = () => {
	const { group, setGroup } = useSignUp();

	return (
		<div className="flex flex-col text-white w-full">
			<div className="flex justify-between items-center w-full mb-3 pt-5 border-t-[0.5px] border-[#1C2D4A]/50">
				<span className="text-white font-bold text-sm">Select your group</span>
				<span className="text-[#B5B6BA] text-xs">Optional</span>
			</div>
			<Select
				value={group}
				onValueChange={(value) => setGroup(value === NO_GROUP_VALUE ? '' : value)}
			>
				<SelectTrigger
					iconSize={24}
					className="w-full bg-[#1E2748] border border-[#506296] text-white text-[16px] rounded-full h-[44px] px-4 focus:outline-hidden data-placeholder:text-[#B5B6BA]"
				>
					<SelectValue placeholder="Select group" />
				</SelectTrigger>
				<SelectContent
					viewportClassName="p-0"
					className="bg-[#1e2748] border-[#506296] border rounded-[8px] p-0 overflow-hidden"
				>
					<div className="bg-[#1e2748] border-b border-[#506296] flex items-center px-[12px] py-[6px]">
						<span className="text-[#5583f6] text-[12px] font-semibold tracking-[0.48px] capitalize">
							Select group
						</span>
					</div>
					{group && (
						<SelectItem
							value={NO_GROUP_VALUE}
							className="bg-[#506296] text-[#B5B6BA] hover:bg-[#506296]/90 focus:bg-[#506296]/90 focus:text-[#eef2ff] rounded-none h-[40px] font-medium text-[14px] cursor-pointer"
							transparentHover
						>
							None
						</SelectItem>
					)}
					{SIGNUP_GROUP_OPTIONS.map(({ value, label }) => (
						<SelectItem
							key={value}
							value={value}
							className="bg-[#506296] text-[#eef2ff] hover:bg-[#506296]/90 focus:bg-[#506296]/90 focus:text-[#eef2ff] rounded-none h-[40px] font-medium text-[14px] cursor-pointer"
							transparentHover
						>
							{label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};
